import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild } from '@angular/router';

import { AuthService } from './services/auth.service';
import { LoggingMessageService } from './services/logging-message.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router, private logger: LoggingMessageService) {}


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    const url: string = state.url;
    return this.checkLogin(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkLogin(url: string): boolean {
    const isLoggedIn = this.authService.isUserLoggedIn();
    if (isLoggedIn === true) { return true; }

    // Navigate to the logout page
    this.logger.warn('auth.guard', 'checkLogin', this.authService.SelectedSubscription , this.authService.AvailableSubscriptionsString, 'Routing to logout page', '');
    this.router.navigate(['/logout']);

    return false;
  }
}
